import { render, staticRenderFns } from "./StormTag.vue?vue&type=template&id=d80f861e&scoped=true"
import script from "./StormTag.vue?vue&type=script&lang=js"
export * from "./StormTag.vue?vue&type=script&lang=js"
import style0 from "./StormTag.vue?vue&type=style&index=0&id=d80f861e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80f861e",
  null
  
)

export default component.exports